import TenderCard from "./components/tender-card";
import Footer from "@/layouts/footer";
import NavPage from "@/layouts/nav-header";
import { RootState } from "@/store/type";
import { useSelector } from "react-redux";

const Card = ({ isShown }: { isShown?: boolean }) => {
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = authUser?.role ?? "";
  return (
    <>
      <div
        className="flex flex-col items-center"
        style={{ background: "#f8fafa" }}
      >
        <div
          className="container mx-auto px-4 py-8"
          style={{ overflow: "auto", paddingTop: isShown ? 130 : 30 }}
        >
          <TenderCard />
        </div>
      </div>
      {!userRole && <Footer />}
    </>
  );
};

function TenderCardPage({ isShown }: { isShown?: boolean }) {
  if (isShown)
    return (
      <NavPage isForm={2}>
        <Card isShown />
      </NavPage>
    );
  if (!isShown) return <Card />;
}

export default TenderCardPage;